import { createFileRoute } from "@tanstack/react-router"
import type * as React from "react"

import { Stack } from "@chakra-ui/react"
import { useEffect } from "react"
import PaymentCancel from "../components/PaymentCancel"
import PaymentCancelParams from "../components/PaymentCancel"

import useFrame from "../hooks/useFrame"

interface PaymentCancelParams {
  session_id: string
}

const PaymentCancelPage: React.FC = () => {
  const { containerRef, sendHeight } = useFrame()

  const session_id = Route.useSearch({
    select: (search) => search.session_id ?? "",
  })
  useEffect(() => {
    sendHeight()
  }, [sendHeight])

  return (
    <>
      <Stack ref={containerRef}>
        <PaymentCancel session_id={session_id} />
      </Stack>
    </>
  )
}

export const Route = createFileRoute("/payment-cancel")({
  component: PaymentCancelPage,
  validateSearch: (search: Record<string, unknown>): PaymentCancelParams => {
    return {
      session_id: (search.session_id as string) || "",
    }
  },
})
